// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1TxVh","active":"downloadDropdown_active__3JcIH"};